import firebase from "datastore/database";

import Api from "util/api";
import fetchDoc from "util/api/fetchDoc";

export async function getBusinessPermissions(businessUid) {
  const subscription = await Api.fetchDoc(`subscriptions/${businessUid}`);
  return getTierPermissions(subscription?.tier);
}

// Do better
export function combinePermissions2(a, b) {
  const perms = {};
  Object.entries(a ?? {}).forEach((entry) => {
    const [name, data] = entry;
    perms[name] = data;
  });
  Object.entries(b ?? {}).forEach((entry) => {
    const [name, data] = entry;
    if (!perms[name]) {
      perms[name] = data;
    } else {
      perms[name] = perms[name] && data;
    }
  });
  return perms;
}

// If either are false, the permission is false
export function combinePermissions(a, b) {
  const perms = {};
  Object.entries(a ?? {}).forEach((entry) => {
    const [name, data] = entry;
    perms[name] = data;
  });
  Object.entries(b ?? {}).forEach((entry) => {
    const [name, data] = entry;
    if (!perms[name]) {
      perms[name] = data;
    } else {
      perms[name] = {
        read: perms[name].read && data.read,
        write: perms[name].write && data.write,
      };
    }
  });
  return perms;
}

export async function getTierPermissions(uid) {
  const tierUid = uid ?? "all"; // Grant "all" permissions if the tier isn't set. This is to prevent errors when we first release this feature
  let currentPermissions = await fetchDoc(`access-controls/${tierUid}`);
  let features = { ...currentPermissions?.features };
  while (currentPermissions?.parent) {
    // eslint-disable-next-line no-await-in-loop
    currentPermissions = await fetchDoc(
      `access-controls/${currentPermissions.parent}`
    );
    features = combinePermissions(features, currentPermissions?.features);
  }
  return features;
}

export async function getPermissions(businessUid, role) {
  const business = await fetchDoc(`businesses/${businessUid}`);
  const groupBuid = business?.businessGroupUid ?? business?.uid;
  let [permissions, tierPermissions] = await Promise.all([
    fetchDoc(`access-controls/business-groups/${groupBuid}/${role}`),
    getBusinessPermissions(businessUid),
  ]);
  let features = { ...permissions?.features };
  let currentPermissions = permissions;
  while (currentPermissions?.parent) {
    // eslint-disable-next-line no-await-in-loop
    currentPermissions = await fetchDoc(
      `access-controls/${currentPermissions.parent}`
    );
    features = combinePermissions(features, currentPermissions?.features);
  }
  features = combinePermissions(features, tierPermissions);
  return features;
}

export async function getGroupPermissions(groupBuid, role) {
  const permissions = await fetchDoc(
    `access-controls/business-groups/${groupBuid}/${role}`
  );
  const tierPermissions = await getTierPermissions(permissions?.tier);
  let features = { ...permissions?.features };
  let currentPermissions = permissions;
  while (currentPermissions?.parent) {
    // eslint-disable-next-line no-await-in-loop
    currentPermissions = await fetchDoc(
      `access-controls/${currentPermissions.parent}`
    );
    features = combinePermissions(features, currentPermissions?.features);
  }
  features = combinePermissions(features, tierPermissions);
  return { features, tier: permissions.tier };
}

export async function updateBusinessPermissions(value, businessUid) {
  const business = await fetchDoc(`businesses/${businessUid}`);
  const groupBuid = business?.businessGroupUid ?? business?.uid;
  const permissionSnaps = await firebase
    .firestore()
    .doc(`access-controls/${value}`)
    .get();
  let data = permissionSnaps.data();
  let permissions = data.features;
  while (data?.parent) {
    //Merge all the permissions while keeping all the false values
    // eslint-disable-next-line no-await-in-loop
    data = await fetchDoc(`access-controls/${data.parent}`);
    permissions = { ...data.features, ...permissions };
  }
  if (permissions) {
    firebase
      .firestore()
      .collection(`access-controls/business-groups/${groupBuid}`)
      .doc("admin")
      .update({ features: permissions });
  }

  const allUserPermissionsSnap = await firebase
    .firestore()
    .collection(`access-controls/business-groups/${groupBuid}`)
    .get();

  const snapshot = allUserPermissionsSnap.docs.map((item) => ({
    uid: item.id,
    ...item.data(),
  }));
  if (snapshot.length === 0) return;
  let adminPermission = {};
  let newFeature = {};
  snapshot.forEach((permission) => {
    if (permission.uid === "admin") {
      adminPermission = permission.features;
    } else {
      Object.entries(permission.features).map((entry) => {
        const [key, value] = entry;
        const oldValue = permission.features[key];
        const newValue = adminPermission[key];

        if (oldValue.read === true && newValue.read === false) {
          newFeature[key] = newValue;
        } else if (newValue.read === true && oldValue.read === false) {
          newFeature[key] = oldValue;
        } else {
          newFeature[key] = oldValue;
        }
      });
      firebase
        .firestore()
        .collection(`access-controls/business-groups/${groupBuid}`)
        .doc(permission.uid)
        .update({ features: newFeature });
      newFeature = {};
    }
  });
}
